export const LANGUAGES = [
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "de", name: "Deutsch" },
  { code: "pt", name: "Português" },
  { code: "ru", name: "Русский" },
];

export const translations = {
  en: {
    nav: { about: "Manifesto", download: "Download", support: "Support", cta: "Download TeamUp" },
    hero: {
      eyebrow: "The football match-finding app",
      lines: ["GAME ON.", "ANYTIME.", "ANYWHERE."],
      sub: "The official home of TeamUp — find local matches, join games in one tap, host your own pitch and connect with footballers around you.",
      primary: "Download TeamUp",
      secondary: "Learn More",
      caption: "Free on iOS & Android",
      scroll: "Scroll",
    },
    marquee: ["Find Matches", "Join Games", "Create Matches", "Connect With Players", "Football Anywhere"],
    about: {
      eyebrow: "The Manifesto",
      heading: "One app. Every game.",
      intro: "TeamUp is the simplest way to find football wherever you are — built for players, by players.",
      chapters: [
        { num: "01", title: "Find Matches", desc: "Discover games near you with real-time availability. Pick a match, check the level, and you're in." },
        { num: "02", title: "Join Games", desc: "Join any game in seconds. One tap claims your spot — no endless group chats required." },
        { num: "03", title: "Create Matches", desc: "Host your own 5v5, 7v7 or 11v11. Set the time, the pitch and the level — players come to you." },
        { num: "04", title: "Connect With Players", desc: "Meet footballers in your city, build your crew and keep your football circle growing." },
        { num: "05", title: "Football Anywhere", desc: "Travelling? New city? TeamUp finds you a game wherever you land. Football follows you." },
      ],
    },
    download: {
      eyebrow: "Get the app",
      heading: "Ready to take the pitch?",
      text: "Download TeamUp and find your next match today. Free on iOS and Android.",
      appStoreTop: "Download on the",
      appStoreBottom: "App Store",
      playTop: "GET IT ON",
      playBottom: "Google Play",
      note: "Live on the App Store — Google Play coming soon.",
      toast: "Google Play goes live soon — the button is ready to connect.",
      domain: "Official home — teamup-app.fr",
    },
    support: {
      eyebrow: "Support",
      heading: "Need a hand?",
      text: "Questions, feedback or partnership ideas — our team reads everything. Reach out and we'll get back to you.",
      contact: "Contact Us",
    },
    footer: {
      tagline: "Find football wherever you are.",
      rights: "© 2026 TeamUp. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      support: "Support",
      contact: "Contact",
      language: "Language",
    },
    legal: {
      back: "Back to home",
      updated: "Last updated: July 2026",
      privacy: {
        title: "Privacy Policy",
        p1: "TeamUp respects your privacy. This page will describe what data we collect when you use the TeamUp app and this website, and how we use it. The full policy is being finalised and will be published here before launch.",
        p2: "We only collect the information needed to run the service — such as your account details and match activity. We never sell your personal data to third parties.",
        p3: "Questions about privacy? Reach us any time through the Contact Us link in the Support section.",
      },
      terms: {
        title: "Terms & Conditions",
        p1: "By using TeamUp you agree to play fair — on and off the pitch. These terms will govern the use of the TeamUp app and this website. The full document will be published here before launch.",
        p2: "TeamUp helps players find and organise matches. Match organisation, attendance and conduct remain the responsibility of the players involved.",
        p3: "Questions about these terms? Contact us through the Support section.",
      },
    },
  },

  es: {
    nav: { about: "Manifiesto", download: "Descargar", support: "Soporte", cta: "Descargar TeamUp" },
    hero: {
      eyebrow: "La app para encontrar partidos de fútbol",
      lines: ["JUEGA.", "CUANDO QUIERAS.", "DONDE SEA."],
      sub: "El sitio oficial de TeamUp — encuentra partidos locales, únete a juegos con un toque, organiza tu cancha y conecta con futbolistas cerca de ti.",
      primary: "Descargar TeamUp",
      secondary: "Saber más",
      caption: "Gratis en iOS y Android",
      scroll: "Desliza",
    },
    marquee: ["Encuentra Partidos", "Únete a Juegos", "Crea Partidos", "Conecta con Jugadores", "Fútbol Donde Sea"],
    about: {
      eyebrow: "El Manifiesto",
      heading: "Una app. Todos los partidos.",
      intro: "TeamUp es la forma más simple de encontrar fútbol estés donde estés — creada por jugadores, para jugadores.",
      chapters: [
        { num: "01", title: "Encuentra Partidos", desc: "Descubre juegos cerca de ti con disponibilidad en tiempo real. Elige un partido, mira el nivel y entra." },
        { num: "02", title: "Únete a Juegos", desc: "Únete a cualquier partido en segundos. Un toque reserva tu lugar — sin chats de grupo interminables." },
        { num: "03", title: "Crea Partidos", desc: "Organiza tu propio 5v5, 7v7 u 11v11. Define la hora, la cancha y el nivel — los jugadores vienen a ti." },
        { num: "04", title: "Conecta con Jugadores", desc: "Conoce futbolistas en tu ciudad, forma tu equipo y haz crecer tu círculo futbolero." },
        { num: "05", title: "Fútbol Donde Sea", desc: "¿De viaje? ¿Ciudad nueva? TeamUp te encuentra un partido donde aterrices. El fútbol te sigue." },
      ],
    },
    download: {
      eyebrow: "Consigue la app",
      heading: "¿Listo para saltar a la cancha?",
      text: "Descarga TeamUp y encuentra tu próximo partido hoy. Gratis en iOS y Android.",
      appStoreTop: "Descárgalo en la",
      appStoreBottom: "App Store",
      playTop: "DISPONIBLE EN",
      playBottom: "Google Play",
      note: "Disponible en App Store — Google Play llegará pronto.",
      toast: "Google Play estará disponible pronto — el botón está listo.",
      domain: "Sitio oficial — teamup-app.fr",
    },
    support: {
      eyebrow: "Soporte",
      heading: "¿Necesitas ayuda?",
      text: "Preguntas, comentarios o ideas de colaboración — nuestro equipo lo lee todo. Escríbenos y te responderemos.",
      contact: "Contáctanos",
    },
    footer: {
      tagline: "Encuentra fútbol donde estés.",
      rights: "© 2026 TeamUp. Todos los derechos reservados.",
      privacy: "Política de Privacidad",
      terms: "Términos y Condiciones",
      support: "Soporte",
      contact: "Contacto",
      language: "Idioma",
    },
    legal: {
      back: "Volver al inicio",
      updated: "Última actualización: julio de 2026",
      privacy: {
        title: "Política de Privacidad",
        p1: "TeamUp respeta tu privacidad. Esta página describirá qué datos recopilamos cuando usas la app de TeamUp y este sitio web, y cómo los usamos. La política completa se está finalizando y se publicará aquí antes del lanzamiento.",
        p2: "Solo recopilamos la información necesaria para operar el servicio — como los datos de tu cuenta y tu actividad en los partidos. Nunca vendemos tus datos personales a terceros.",
        p3: "¿Preguntas sobre privacidad? Escríbenos en cualquier momento desde el enlace de contacto en la sección de Soporte.",
      },
      terms: {
        title: "Términos y Condiciones",
        p1: "Al usar TeamUp aceptas jugar limpio — dentro y fuera de la cancha. Estos términos regirán el uso de la app y del sitio web de TeamUp. El documento completo se publicará aquí antes del lanzamiento.",
        p2: "TeamUp ayuda a los jugadores a encontrar y organizar partidos. La organización, asistencia y conducta en los partidos son responsabilidad de los jugadores involucrados.",
        p3: "¿Preguntas sobre estos términos? Contáctanos desde la sección de Soporte.",
      },
    },
  },

  fr: {
    nav: { about: "Manifeste", download: "Télécharger", support: "Support", cta: "Télécharger TeamUp" },
    hero: {
      eyebrow: "L'appli pour trouver des matchs de foot",
      lines: ["RÉSERVE.", "JOUE.", "N'IMPORTE OÙ."],
      sub: "Le site officiel de TeamUp — trouvez des matchs locaux, rejoignez des parties en un tap, organisez votre terrain et connectez-vous avec les footballeurs autour de vous.",
      primary: "Télécharger TeamUp",
      secondary: "En savoir plus",
      caption: "Gratuit sur iOS et Android",
      scroll: "Défiler",
    },
    marquee: ["Trouve des Matchs", "Rejoins des Parties", "Crée des Matchs", "Connecte les Joueurs", "Du Foot Partout"],
    about: {
      eyebrow: "Le Manifeste",
      heading: "Une appli. Tous les matchs.",
      intro: "TeamUp est le moyen le plus simple de trouver du foot où que tu sois — conçu par des joueurs, pour des joueurs.",
      chapters: [
        { num: "01", title: "Trouve des Matchs", desc: "Découvre des matchs près de chez toi avec disponibilité en temps réel. Choisis un match, vérifie le niveau, et c'est parti." },
        { num: "02", title: "Rejoins des Parties", desc: "Rejoins n'importe quel match en quelques secondes. Un tap pour prendre ta place — fini les groupes de discussion sans fin." },
        { num: "03", title: "Crée des Matchs", desc: "Organise ton propre 5v5, 7v7 ou 11v11. Fixe l'heure, le terrain et le niveau — les joueurs viennent à toi." },
        { num: "04", title: "Connecte les Joueurs", desc: "Rencontre des footballeurs dans ta ville, constitue ton équipe et agrandis ton cercle foot." },
        { num: "05", title: "Du Foot Partout", desc: "En voyage ? Nouvelle ville ? TeamUp te trouve un match où que tu atterrisses. Le foot te suit." },
      ],
    },
    download: {
      eyebrow: "Télécharge l'appli",
      heading: "Prêt à fouler la pelouse ?",
      text: "Télécharge TeamUp et trouve ton prochain match dès aujourd'hui. Gratuit sur iOS et Android.",
      appStoreTop: "Télécharger sur l'",
      appStoreBottom: "App Store",
      playTop: "DISPONIBLE SUR",
      playBottom: "Google Play",
      note: "Disponible sur l'App Store — Google Play arrive bientôt.",
      toast: "Google Play arrive bientôt — le bouton est prêt.",
      domain: "Site officiel — teamup-app.fr",
    },
    support: {
      eyebrow: "Support",
      heading: "Besoin d'aide ?",
      text: "Questions, retours ou idées de partenariat — notre équipe lit tout. Écris-nous et on te répondra.",
      contact: "Nous contacter",
    },
    footer: {
      tagline: "Trouve du foot où que tu sois.",
      rights: "© 2026 TeamUp. Tous droits réservés.",
      privacy: "Politique de Confidentialité",
      terms: "Conditions Générales",
      support: "Support",
      contact: "Contact",
      language: "Langue",
    },
    legal: {
      back: "Retour à l'accueil",
      updated: "Dernière mise à jour : juillet 2026",
      privacy: {
        title: "Politique de Confidentialité",
        p1: "TeamUp respecte ta vie privée. Cette page décrira quelles données nous collectons lorsque tu utilises l'appli TeamUp et ce site, et comment nous les utilisons. La politique complète est en cours de finalisation et sera publiée ici avant le lancement.",
        p2: "Nous ne collectons que les informations nécessaires au fonctionnement du service — comme les données de ton compte et ton activité de match. Nous ne vendons jamais tes données personnelles à des tiers.",
        p3: "Des questions sur la confidentialité ? Écris-nous à tout moment via le lien de contact dans la section Support.",
      },
      terms: {
        title: "Conditions Générales",
        p1: "En utilisant TeamUp, tu acceptes de jouer fair-play — sur le terrain comme en dehors. Ces conditions régiront l'utilisation de l'appli et du site TeamUp. Le document complet sera publié ici avant le lancement.",
        p2: "TeamUp aide les joueurs à trouver et organiser des matchs. L'organisation, la présence et le comportement lors des matchs restent de la responsabilité des joueurs impliqués.",
        p3: "Des questions sur ces conditions ? Contacte-nous via la section Support.",
      },
    },
  },

  de: {
    nav: { about: "Manifest", download: "Download", support: "Support", cta: "TeamUp laden" },
    hero: {
      eyebrow: "Die App, um Fußballspiele zu finden",
      lines: ["SPIEL FREI.", "JEDERZEIT.", "ÜBERALL."],
      sub: "Die offizielle Heimat von TeamUp — finde Spiele in deiner Nähe, tritt mit einem Tap bei, organisiere deinen eigenen Platz und vernetze dich mit Fußballern um dich herum.",
      primary: "TeamUp herunterladen",
      secondary: "Mehr erfahren",
      caption: "Kostenlos für iOS & Android",
      scroll: "Scrollen",
    },
    marquee: ["Finde Spiele", "Tritt Spielen Bei", "Erstelle Matches", "Vernetze Spieler", "Fußball Überall"],
    about: {
      eyebrow: "Das Manifest",
      heading: "Eine App. Jedes Spiel.",
      intro: "TeamUp ist der einfachste Weg, Fußball zu finden – egal wo du bist. Von Spielern, für Spieler.",
      chapters: [
        { num: "01", title: "Finde Spiele", desc: "Entdecke Spiele in deiner Nähe mit Verfügbarkeit in Echtzeit. Wähle ein Match, sieh das Niveau – und du bist dabei." },
        { num: "02", title: "Tritt Spielen Bei", desc: "Tritt jedem Spiel in Sekunden bei. Ein Tap sichert deinen Platz – ohne endlose Gruppenchats." },
        { num: "03", title: "Erstelle Matches", desc: "Organisiere dein eigenes 5v5, 7v7 oder 11v11. Lege Zeit, Platz und Niveau fest – die Spieler kommen zu dir." },
        { num: "04", title: "Vernetze Spieler", desc: "Lerne Fußballer in deiner Stadt kennen, baue dein Team und lass deinen Fußballkreis wachsen." },
        { num: "05", title: "Fußball Überall", desc: "Auf Reisen? Neue Stadt? TeamUp findet dir überall ein Spiel. Der Fußball folgt dir." },
      ],
    },
    download: {
      eyebrow: "Hol dir die App",
      heading: "Bereit für den Platz?",
      text: "Lade TeamUp herunter und finde heute noch dein nächstes Spiel. Kostenlos für iOS und Android.",
      appStoreTop: "Laden im",
      appStoreBottom: "App Store",
      playTop: "JETZT BEI",
      playBottom: "Google Play",
      note: "Jetzt im App Store — Google Play folgt bald.",
      toast: "Google Play folgt bald – der Button ist bereit.",
      domain: "Offizielle Website — teamup-app.fr",
    },
    support: {
      eyebrow: "Support",
      heading: "Brauchst du Hilfe?",
      text: "Fragen, Feedback oder Partnerschaftsideen – unser Team liest alles. Schreib uns und wir melden uns.",
      contact: "Kontakt",
    },
    footer: {
      tagline: "Finde Fußball, wo immer du bist.",
      rights: "© 2026 TeamUp. Alle Rechte vorbehalten.",
      privacy: "Datenschutzerklärung",
      terms: "AGB",
      support: "Support",
      contact: "Kontakt",
      language: "Sprache",
    },
    legal: {
      back: "Zurück zur Startseite",
      updated: "Zuletzt aktualisiert: Juli 2026",
      privacy: {
        title: "Datenschutzerklärung",
        p1: "TeamUp respektiert deine Privatsphäre. Diese Seite wird beschreiben, welche Daten wir bei der Nutzung der TeamUp-App und dieser Website erheben und wie wir sie verwenden. Die vollständige Erklärung wird derzeit finalisiert und vor dem Launch hier veröffentlicht.",
        p2: "Wir erheben nur die Informationen, die für den Betrieb des Dienstes nötig sind – etwa deine Kontodaten und Spielaktivität. Wir verkaufen deine persönlichen Daten niemals an Dritte.",
        p3: "Fragen zum Datenschutz? Erreich uns jederzeit über den Kontakt-Link im Support-Bereich.",
      },
      terms: {
        title: "Allgemeine Geschäftsbedingungen",
        p1: "Mit der Nutzung von TeamUp erklärst du dich bereit, fair zu spielen – auf und neben dem Platz. Diese Bedingungen regeln die Nutzung der TeamUp-App und Website. Das vollständige Dokument wird vor dem Launch hier veröffentlicht.",
        p2: "TeamUp hilft Spielern, Spiele zu finden und zu organisieren. Organisation, Teilnahme und Verhalten bei den Spielen liegen in der Verantwortung der beteiligten Spieler.",
        p3: "Fragen zu diesen Bedingungen? Kontaktiere uns über den Support-Bereich.",
      },
    },
  },

  pt: {
    nav: { about: "Manifesto", download: "Baixar", support: "Suporte", cta: "Baixar TeamUp" },
    hero: {
      eyebrow: "O app para encontrar partidas de futebol",
      lines: ["JOGA.", "A QUALQUER HORA.", "EM QUALQUER LUGAR."],
      sub: "A casa oficial do TeamUp — encontra partidas locais, entra em jogos com um toque, organiza o teu campo e conecta-te com futebolistas à tua volta.",
      primary: "Baixar TeamUp",
      secondary: "Saber mais",
      caption: "Grátis para iOS e Android",
      scroll: "Rolar",
    },
    marquee: ["Encontra Partidas", "Entra em Jogos", "Cria Partidas", "Conecta Jogadores", "Futebol em Qualquer Lugar"],
    about: {
      eyebrow: "O Manifesto",
      heading: "Um app. Todos os jogos.",
      intro: "O TeamUp é a forma mais simples de encontrar futebol onde quer que estejas — feito por jogadores, para jogadores.",
      chapters: [
        { num: "01", title: "Encontra Partidas", desc: "Descobre jogos perto de ti com disponibilidade em tempo real. Escolhe uma partida, vê o nível e entra." },
        { num: "02", title: "Entra em Jogos", desc: "Entra em qualquer jogo em segundos. Um toque garante o teu lugar — sem conversas de grupo infinitas." },
        { num: "03", title: "Cria Partidas", desc: "Organiza o teu próprio 5x5, 7x7 ou 11x11. Define a hora, o campo e o nível — os jogadores vêm até ti." },
        { num: "04", title: "Conecta Jogadores", desc: "Conhece futebolistas na tua cidade, monta a tua equipa e faz crescer o teu círculo de futebol." },
        { num: "05", title: "Futebol em Qualquer Lugar", desc: "A viajar? Cidade nova? O TeamUp encontra-te um jogo onde quer que aterres. O futebol segue-te." },
      ],
    },
    download: {
      eyebrow: "Obtém a app",
      heading: "Pronto para entrar em campo?",
      text: "Baixa o TeamUp e encontra a tua próxima partida hoje. Grátis para iOS e Android.",
      appStoreTop: "Descarregar na",
      appStoreBottom: "App Store",
      playTop: "DISPONÍVEL NO",
      playBottom: "Google Play",
      note: "Disponível na App Store — Google Play em breve.",
      toast: "Google Play chega em breve — o botão está pronto.",
      domain: "Site oficial — teamup-app.fr",
    },
    support: {
      eyebrow: "Suporte",
      heading: "Precisas de ajuda?",
      text: "Perguntas, feedback ou ideias de parceria — a nossa equipa lê tudo. Escreve-nos e responderemos.",
      contact: "Fala connosco",
    },
    footer: {
      tagline: "Encontra futebol onde quer que estejas.",
      rights: "© 2026 TeamUp. Todos os direitos reservados.",
      privacy: "Política de Privacidade",
      terms: "Termos e Condições",
      support: "Suporte",
      contact: "Contacto",
      language: "Idioma",
    },
    legal: {
      back: "Voltar ao início",
      updated: "Última atualização: julho de 2026",
      privacy: {
        title: "Política de Privacidade",
        p1: "O TeamUp respeita a tua privacidade. Esta página descreverá que dados recolhemos quando usas a app TeamUp e este site, e como os usamos. A política completa está a ser finalizada e será publicada aqui antes do lançamento.",
        p2: "Recolhemos apenas a informação necessária para operar o serviço — como os dados da tua conta e a tua atividade em jogos. Nunca vendemos os teus dados pessoais a terceiros.",
        p3: "Dúvidas sobre privacidade? Fala connosco a qualquer momento através do link de contacto na secção de Suporte.",
      },
      terms: {
        title: "Termos e Condições",
        p1: "Ao usar o TeamUp concordas em jogar limpo — dentro e fora de campo. Estes termos regem o uso da app e do site TeamUp. O documento completo será publicado aqui antes do lançamento.",
        p2: "O TeamUp ajuda jogadores a encontrar e organizar partidas. A organização, presença e conduta nos jogos são da responsabilidade dos jogadores envolvidos.",
        p3: "Dúvidas sobre estes termos? Contacta-nos através da secção de Suporte.",
      },
    },
  },

  ru: {
    nav: { about: "Манифест", download: "Скачать", support: "Поддержка", cta: "Скачать TeamUp" },
    hero: {
      eyebrow: "Приложение для поиска футбольных матчей",
      lines: ["ИГРАЙ.", "В ЛЮБОЕ ВРЕМЯ.", "ВЕЗДЕ."],
      sub: "Официальный сайт TeamUp — находи локальные матчи, присоединяйся к играм в один тап, собирай своё поле и общайся с футболистами вокруг.",
      primary: "Скачать TeamUp",
      secondary: "Узнать больше",
      caption: "Бесплатно на iOS и Android",
      scroll: "Листай",
    },
    marquee: ["Находи Матчи", "Присоединяйся к Играм", "Создавай Матчи", "Общайся с Игроками", "Футбол Везде"],
    about: {
      eyebrow: "Манифест",
      heading: "Одно приложение. Все матчи.",
      intro: "TeamUp — самый простой способ найти футбол, где бы ты ни был. Создано игроками для игроков.",
      chapters: [
        { num: "01", title: "Находи Матчи", desc: "Открывай игры рядом с тобой с доступностью в реальном времени. Выбери матч, посмотри уровень — и ты в игре." },
        { num: "02", title: "Присоединяйся к Играм", desc: "Присоединяйся к любой игре за секунды. Один тап — и место твоё. Без бесконечных групповых чатов." },
        { num: "03", title: "Создавай Матчи", desc: "Организуй свой 5x5, 7x7 или 11x11. Укажи время, поле и уровень — игроки придут сами." },
        { num: "04", title: "Общайся с Игроками", desc: "Знакомься с футболистами в своём городе, собирай команду и расширяй футбольный круг." },
        { num: "05", title: "Футбол Везде", desc: "В поездке? Новый город? TeamUp найдёт тебе игру где угодно. Футбол следует за тобой." },
      ],
    },
    download: {
      eyebrow: "Скачай приложение",
      heading: "Готов выйти на поле?",
      text: "Скачай TeamUp и найди свой следующий матч уже сегодня. Бесплатно на iOS и Android.",
      appStoreTop: "Загрузить в",
      appStoreBottom: "App Store",
      playTop: "СКАЧАТЬ В",
      playBottom: "Google Play",
      note: "Уже в App Store — Google Play скоро.",
      toast: "Google Play появится скоро — кнопка готова.",
      domain: "Официальный сайт — teamup-app.fr",
    },
    support: {
      eyebrow: "Поддержка",
      heading: "Нужна помощь?",
      text: "Вопросы, отзывы или идеи партнёрства — наша команда читает всё. Напиши нам, и мы ответим.",
      contact: "Связаться с нами",
    },
    footer: {
      tagline: "Находи футбол, где бы ты ни был.",
      rights: "© 2026 TeamUp. Все права защищены.",
      privacy: "Политика конфиденциальности",
      terms: "Условия использования",
      support: "Поддержка",
      contact: "Контакт",
      language: "Язык",
    },
    legal: {
      back: "На главную",
      updated: "Последнее обновление: июль 2026",
      privacy: {
        title: "Политика конфиденциальности",
        p1: "TeamUp уважает твою конфиденциальность. На этой странице будет описано, какие данные мы собираем при использовании приложения TeamUp и этого сайта, и как мы их используем. Полная версия политики дорабатывается и будет опубликована здесь до запуска.",
        p2: "Мы собираем только информацию, необходимую для работы сервиса — например, данные аккаунта и игровую активность. Мы никогда не продаём личные данные третьим лицам.",
        p3: "Вопросы о конфиденциальности? Напиши нам в любое время через ссылку связи в разделе Поддержки.",
      },
      terms: {
        title: "Условия использования",
        p1: "Используя TeamUp, ты соглашаешься играть честно — на поле и за его пределами. Эти условия регулируют использование приложения и сайта TeamUp. Полный документ будет опубликован здесь до запуска.",
        p2: "TeamUp помогает игрокам находить и организовывать матчи. Организация, посещение и поведение на матчах остаются ответственностью участвующих игроков.",
        p3: "Вопросы об этих условиях? Свяжись с нами через раздел Поддержки.",
      },
    },
  },
};
